<tabs-inner-wrap>
  <simulation-prompts [isQcAdmin]="isQcAdmin()" [isRefinementInProgress]="isRefinementInProgress()" (conversePromptOverridden)="conversePromptOverridden.emit()"></simulation-prompts>
</tabs-inner-wrap>
